import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { authenticatedSelector } from 'selectors/profileSelectors';
import { haveUpcomingOrCurrentTripSelector } from 'selectors/tripsSelectors';
import UserCurrentNextTrip from 'components/UserCurrentNextTrip';

/**
 * AuthHomeCurrentNextTrip
 *
 * @return {JSX}
 */
const AuthHomeCurrentNextTrip = () => {
  const [isFetching, setIsFetching] = useState(true);
  const isAuthenticated = useSelector(authenticatedSelector);
  const haveUpcomingOrCurrentTrip = useSelector(haveUpcomingOrCurrentTripSelector);
  const shouldRender = isAuthenticated && (isFetching || haveUpcomingOrCurrentTrip);

  return shouldRender ? (
    <section className='theme--light-blue padding-top--condensed padding-bottom--condensed auth-current-next-trip'>
      <section className='aem-Grid aem-Grid--12 aem-Grid--default--12'>
        <UserCurrentNextTrip onFetch={setIsFetching} />
      </section>
    </section>
  ) : null;
};

export default AuthHomeCurrentNextTrip;
